import { IComponent, IComponentCategory, IComponentSetDto } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import _ from "lodash";
import * as React from "react";
import { ComponentSetService } from "../../../../services/component-set-service";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { KModal } from "../../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../../ui-kit/k-modal/k-modal-footer";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import ComponentSetCategories from "./component-set-categories";
import "./component-category-list.scss";

/** Ties the footer submit button to the form it lives outside of. */
const CATEGORY_FORM_ID = "componentCategoryForm";

export interface IComponentSetAddState {
  isSubmitButtonLoading: boolean;
  collapseActiveKey: string;
  componentSet: IComponentSetDto;
  initialValue: IComponentCategory;
}

export interface IComponentSetAddProps {
  closeModal: any;
  showModal: boolean;
  onCategoryListUpdated: any;
  component: IComponent;
  selectedComponentSetId: string;
}

class ComponentCategoryList extends React.PureComponent<IComponentSetAddProps, IComponentSetAddState> {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitButtonLoading: false,
      collapseActiveKey: "0",
      componentSet: {} as IComponentSetDto,
      initialValue: {} as IComponentCategory
    };
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.component) {
      try {
        const response = await ComponentSetService.Get("4bd34537-525c-4a7c-dde0-08d911312c71");
        if (response.status === 200) {
          const componentSets = [] as IComponentSetDto[];
          componentSets.push(response.data);
          const componentSet = componentSets.filter((c) => c.id === this.props.selectedComponentSetId)[0];
          if (componentSet?.json) {
            const parsedJSON = JSON.parse(componentSet.json);
            if (parsedJSON?.categoryList) {
              this.setState({ initialValue: parsedJSON.categoryList });
            } else {
              this.setState({ initialValue: [] as any });
            }
          }
          this.setState({ componentSet });
        }
      } catch (error: any) {
        KMainFunctions.exceptionHandler(error);
      }
    }
  }

  onSubmit = async (data: any) => {
    try {
      const categoryList = data.categories;
      const isCategoryNameEmpty = categoryList.some((item) => item.categoryName === "");

      if (isCategoryNameEmpty === false) {
        this.setState({ isSubmitButtonLoading: true });

        const copyState = _.cloneDeep(this.state.componentSet);
        let parsedJSON = JSON.parse(copyState.json);
        parsedJSON.categoryList = data.categories;
        parsedJSON = JSON.stringify(parsedJSON);

        const componentSetObj = {} as IComponentSetDto;
        componentSetObj.name = copyState.name;
        componentSetObj.json = parsedJSON;

        // const res = await ComponentSetService.Update(copyState.id, componentSetObj);
        // if (res && res.status === 200) {
        //   KMainFunctions.displaySuccessNotification("Component categories added.");
        //   this.props.onCategoryListUpdated(true);
        //   this.props.closeModal();
        // }
      } else {
        KMainFunctions.displayWarningNotification("Category name should not empty.");
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isSubmitButtonLoading: false });
    }
  };

  onFinishFailed = (errorInfo) => {};

  render() {
    return (
      <KModal
        className="kuika-category-modal"
        showModal={this.props.showModal}
        closeModal={this.props.closeModal}
        header="Component Categories"
        width={760}
        centered
        dontRenderSpinner
        footer={
          <KModalFooter
            onCancel={this.props.closeModal}
            cancelTestId="componentCategoryCancelButton"
            submitLabel="Save"
            submitTestId="componentCategorySaveButton"
            submitForm={CATEGORY_FORM_ID}
            loading={this.state.isSubmitButtonLoading}
          />
        }
      >
        <div className="kuika-category-modal__body" data-testid="componentCategoryModal">
          <KuikaSmallText className="kuika-category-modal__caption">
            Categories group the components in the designer&apos;s toolbox. A name is letters only and must be unique.
          </KuikaSmallText>
          <Form
            id={CATEGORY_FORM_ID}
            name="basic"
            onFinish={this.onSubmit}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              categories: this.state.initialValue ? this.state.initialValue : ([] as IComponentCategory[])
            }}
          >
            {/* `categories` is the wire field the submit reads back — keep the name. */}
            <Form.Item name="categories" noStyle>
              <ComponentSetCategories />
            </Form.Item>
          </Form>
        </div>
      </KModal>
    );
  }
}

const componentCategoryList = ComponentCategoryList;
export { componentCategoryList as ComponentCategoryList };
